<template>
  <div id="login-wrap">
    <div class="login-title">用户登录</div>
    <div class="login-form">
      <Form ref="formLogin" :model="formLogin" :rules="ruleLogin">
        <FormItem prop="username">
          <Input type="text" v-model="formLogin.username" placeholder="用户名">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" v-model="formLogin.password" placeholder="密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formLogin')"> 登 录 </Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import axios from "axios"
export default {
  data () {
    return {
      formLogin: {
        username: '',
        password: ''
      },
      ruleLogin: {
        username: [
          { required: true, message: '请您输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请您输入密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码至少为6位字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this  
          axios.post(
            vm.GLOBAL_API.apiUrl + "/auth/login",
            vm.formLogin
          ).then(function(res) {
            let info = res.data
            let errCode = parseInt(info.code);
            if(!isNaN(errCode) && errCode==0) {
              localStorage.setItem("adminInfo", JSON.stringify(info.data));
              window.open(vm.$router.resolve({ path: '/manage/home/'}).href, "_self")
            } else {
              vm.$Message.error('账号或密码错误');
            }
          }).catch(function(error) {
            vm.$Message.error({
              content: '账号或密码错误',
              closable: true
            });
            console.log(error)
          });
        } else {
          this.$Message.error('请您正确填写登录信息');
        }
      })
    }
  }
}
</script>